export default {
  CAPTURE: 'CAPTURE',
  MANAGER: 'MANAGER',
};
